<template>
  <div class="addFile" :updateFileList="updateFileList" :updatePicList="updatePicList">
    <div class="addCourseware">
      <div class="addCourseBtn">
        <p>课件类型：</p>
        <a href="javascript:;" >
          从我的电脑选择
          <input type="file" accept="ppt/*,pptx/*,pdf/*,doc/*,docx/*,rtf/*,xls/*" @change="changeFn($event,1)">
        </a>
      </div>
      <ul class="filelist">
        <li v-for="(file,index) in FileList" :key="index">
          <div v-show="true">
            <i class="el-icon-circle-close" @click="removeFile(index,1)"></i>
            <a><img :src="file.url" alt=""></a>
            <b >{{file.attach_name}}</b>
          </div>
          <ProgressBar v-show="!file.creator" :step="steps" :initVal="initVal" :stopVal="stopVal" :isOk="isOk"
                       @callback="show"></ProgressBar>
        </li>
      </ul>
    </div>

    <div class="addOther" >
      <div class="addCourseBtn">
        <p>其他图片：</p>
        <a href="javascript:;" >
          从我的电脑选择 <input type="file" @change="changeFn($event,2)" accept="image/*">
        </a>
      </div>
      <ul>
        <li v-for="(file,index) in PicList" :key="index">
          <div v-show="true">
            <i class="el-icon-circle-close" @click="removeFile(index,2)"></i>
            <a><img :src="file.fileurl || file.url" alt=""></a>
            <b>{{file.attach_name}}</b>
          </div>
          <ProgressBar v-show="!file.creator" :step="steps" :initVal="initVal" :stopVal="stopVal" :isOk="isOk"
                       @callback="show" ></ProgressBar>
        </li>
      </ul>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import ProgressBar from '@/components/common/upload/ProgressBar'
  import http from '@/api/http'
  import axios from 'axios'
  import * as _ from '@/common/js/config'

  export default {
    components: {
      ProgressBar,
    },
    props: {
      boxName: {
        type: String,
        default: ''
      },
      updateFileList: {
        type: Array,
        default() {
          return []
        }
      },
      updatePicList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        FileList: [],
        PicList: [],
        fileType: ['.ppt','.pptx', '.pdf','.doc', '.docx','.rtf','.xls'],
        picType:['.jpg', '.png','.gif','.bmp'],
        steps: 2,
        initVal: 0,
        stopVal: 70,
        name:'',
        isOk: false,
        severIds:　[],
        bIsCanSubmit: false,
        bFileUpload: false,
        nIe11Number: 0
      }
    },
    mounted() {
    },
    methods: {
      show(val) {
        if (val == "success") {
          //this.isOk = false;
        }
      },
      changeFn(e, type) {
        let list;
        let len = 10
        let isIe = false
        let userAgent = window.navigator.userAgent
        if (userAgent.indexOf('NET') != -1 && userAgent.indexOf("rv") != -1) {
          let strStart = userAgent.indexOf('rv');
          let strStop = userAgent.indexOf(')');
          let temp = userAgent.substring(strStart, strStop);
          let broName = temp.replace('rv', 'IE').replace(':', '版本号');
          len = 11
          isIe = true
        }
        if (this.bFileUpload) {
          this.$message.error('上一个文件还在上传中')
          e.target.value=''
          return false
        }
        type == 1 ? list = this.FileList : list = this.PicList;
        if (list.length >= len) {
          this.$message.error('最多只能上传10个附件')
          e.target.value=''
          if (isIe) {
            list.pop()
            // console.log(list.length)
          }
          return false
        }
        let deviceFile = e.target.files;
        let formData = new FormData();
        list.push({
          attach_name: deviceFile[0].name,
          url: ''
        })
        // console.log(deviceFile[0])
        let ext = deviceFile[0].name.slice(deviceFile[0].name.lastIndexOf(".") + 1)
        if (type === 1) {
          if (deviceFile[0].type.indexOf('image') > -1) {
            alert('支持30M以内.pptx/.docx/.pdf/.xlsx课件格式')
            list.splice(list.indexOf(deviceFile[0]), 1)
            e.target.value=''
            return false
          }
        } else {
          if (!(deviceFile[0].type.indexOf('image') > -1)) {
            alert('3M以内.jpg/.png/.bmp/.gif格式图片与预览')
            list.splice(list.indexOf(deviceFile[0]), 1)
            e.target.value=''
            return false
          }
        }
        formData.append('attachement', deviceFile[0])
       // console.log(formData)
        e.target.value=''
        this.bIsCanSubmit = true
        this.bFileUpload = true
        this.$emit('fileIsLoading', this.bIsCanSubmit)
        axios.post(`${window.BASE_URL}system/uploadAttachement.json`, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
          if (res.data.code === _.ERR_OK) {
            // console.log('----------------------')
            // console.log(formData)

          if (res.data.model.fileType === 'file') {
            if (res.data.model.fileSize / (1024 * 1024) > 30) {
              this.$message.error('上传的文件大小不能超过30MB')
              return false
            }
          } else {
            if (res.data.model.fileSize / (1024 * 1024) > 3) {
              this.$message.error('上传的文件大小不能超过3MB')
              return false
            }
          }
          this.severIds.push(res.data.model)
          list[list.length - 1].url = res.data.model.filePathUrl
          list[list.length - 1].fileid = res.data.model.filerServerID
          list[list.length - 1].attach_size = res.data.model.fileSize
          list[list.length - 1].attach_type = res.data.model.fileType
          this.isOk = !this.isOk;
          let aSubArr = this.FileList.concat(this.PicList)
          this.$emit('fileChange', aSubArr)
          this.bIsCanSubmit = false
          this.$emit('fileIsLoading', this.bIsCanSubmit)
          this.bFileUpload = false
          // console.log(ext)
          if (ext == 'xls' || ext === 'xlsx') { //判断类型显示图标
            list[list.length - 1].url = './static/image/xlsicon.png'
          } else if (ext == 'doc' || ext == 'rtf' || ext == 'docx' ) {
            list[list.length - 1].url = './static/image/docicon.png'
          } else if (ext == 'pdf') {
            list[list.length - 1].url =  './static/image/pdficon.png'
          } else if (ext == 'ppt' || ext == 'pptx') {
            list[list.length - 1].url = './static/image/ppticon.png'
          } else {
            list[list.length - 1].url = res.data.model.filePathUrl
          }
        } else {
          if (type === 1) {
            this.$message.error('支持30M以内.pptx/.docx/.pdf/.xlsx课件格式')
          } else {
            this.$message.error('支持3M以内.jpg/.png/.bmp/.gif格式图片')
          }
          this.bFileUpload = false
          list.splice(list.indexOf(deviceFile[0]), 1)
        }
        })
      },
      //移除文件
      removeFile(index, type) {
        this.$confirm('确定要删除该附件吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.bFileUpload = false
          this.nIe11Number = 0
          let list = type == 1 ? list = this.FileList.splice(index, 1)  : list = this.PicList.splice(index, 1) ;
          let aSubArr = this.FileList.concat(this.PicList)
          this.$emit('fileChange', aSubArr)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      layout() {
        let [width, els] = [document.getElementById(this.boxName).clientWidth - 120 + 'px', document.getElementsByClassName('filelist')]
        for (let item of els) {
          item.style.width = width
        }
      },
    },
    created() {
      this.FileList = this.updateFileList
      this.PicList = this.updatePicList
      // console.log(this.FileList)
      for (let item of this.FileList) {
        let sExt = item.attach_name.substring(item.attach_name.lastIndexOf('.') + 1)
        if (sExt == 'xls' || sExt === 'xlsx') { //判断类型显示图标
          item.url = './static/image/xlsicon.png'
        } else if (sExt == 'doc' || sExt == 'rtf' || sExt == 'docx' ) {
          item.url = './static/image/docicon.png'
        } else if (sExt == 'pdf') {
          item.url =  './static/image/pdficon.png'
        } else if (sExt == 'ppt' || sExt == 'pptx') {
          item.url = './static/image/ppticon.png'
        } else {
          item.url = res.data.model.filePathUrl
        }
      }
    }
  }
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .addFile
    // min-height: 460px
    overflow-y: auto
    padding-left: 20px
    .addCourseware
    .addOther
      width: 100%
      min-height: 170px
      overflow: hidden
      padding-top: 6px
      .addCourseBtn
        width: 120px
        float: left
        p
          text-align: center
          line-height: 40px
        a
          display: inline-block
          padding: 4px
          height: 20px
          line-height: 20px
          border-radius: 3px
          color: $button-text-color
          background: $color-background-hover
          position: relative
          input[type=file]
            position: absolute
            top: 0
            left: 0
            opacity: 0
            display: block
            width: 106px
            height: 28px
      ul
        float: left
        width: calc(100% - 120px)
        li
          float: left
          width: 102px
          min-height: 160px
          position: relative
          margin: 0 15px
          i
            position: absolute
            width: 14px
            height: 14px
            border-radius:7px
            background: #fff
            right: -5px
            top: -5px
          b
            text-align: center
            padding: 4px 0
            line-height: 24px
            width: 100px
            display: block
            word-wrap: break-word
            word-break: normal
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
          a
            border: 1px solid #dbdbdb
            display: flex
            align-items:center
            width: 100px
            height: 100px
            img
              max-width: 90px
              max-height: 90px
              margin: 10px auto


</style>



// WEBPACK FOOTER //
// uploadFile1.vue?e5aa700c